import { FormattedMessage } from "react-intl";
import { Button, Heading } from "@lendcord/concord";
import { CreditorStatCard } from "@/features/creditor/components/CreditorStatCard";
import { useGetCreditorOverviewQuery } from "@/features/creditor/api/creditor.api";

const currencyFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

const countFormatter = new Intl.NumberFormat("en-IN");

function handleAddBorrower() {
  // TODO: wire to the real add-borrower flow once it exists.
}

interface CreditorOverviewProps {
  onViewInvestors: () => void;
  onViewEmiDashboard: () => void;
  onViewBorrowers: () => void;
}

export function CreditorOverview({ onViewInvestors, onViewEmiDashboard, onViewBorrowers }: CreditorOverviewProps) {
  const { data: overview } = useGetCreditorOverviewQuery();

  return (
    <div>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <Heading level={2}>
          <FormattedMessage id="lender.creditor.overviewHeading" />
        </Heading>
        <div className="flex items-center gap-3">
          <Button type="button" onClick={handleAddBorrower}>
            <FormattedMessage id="lender.creditor.addBorrowerButton" />
          </Button>
          <Button type="button" variant="secondary" onClick={onViewEmiDashboard}>
            <FormattedMessage id="lender.creditor.emiDashboardButton" />
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <CreditorStatCard
          labelId="lender.creditor.totalLoanAmountLabel"
          value={overview ? currencyFormatter.format(overview.totalLoanAmountDisbursed) : ""}
          loading={!overview}
        />
        <CreditorStatCard
          labelId="lender.creditor.totalBorrowersLabel"
          value={overview ? countFormatter.format(overview.totalBorrowers) : ""}
          loading={!overview}
          showViewList
          onViewListClick={onViewBorrowers}
        />
        <CreditorStatCard
          labelId="lender.creditor.totalInvestorsLabel"
          value={overview ? countFormatter.format(overview.totalInvestors) : ""}
          loading={!overview}
          showViewList
          onViewListClick={onViewInvestors}
        />
        <CreditorStatCard
          labelId="lender.creditor.walletBalanceLabel"
          value={overview ? currencyFormatter.format(overview.walletBalance) : ""}
          loading={!overview}
        />
        <CreditorStatCard
          labelId="lender.creditor.principalOutstandingLabel"
          value={overview ? currencyFormatter.format(overview.principalOutstanding) : ""}
          loading={!overview}
        />
        <CreditorStatCard
          labelId="lender.creditor.currentMonthEmiDueLabel"
          value={overview ? currencyFormatter.format(overview.currentMonthEmiDue) : ""}
          loading={!overview}
        />
      </div>
    </div>
  );
}
